import * as _4 from 'lodash4';
import { ISection } from '../../../../../interfaces/scheduler_interfaces';
import { IRegisterSectionsDatasource } from '../../../../course_scheduler/datasources/register_sections_datasource';

class PinScheduledSections {
  private scheduledSections: ISection[];
  private scheduledMultiSections: ISection[];
  private isActionAllowed: boolean = false;
  private scheduledMultiSectionSessions: any;

  constructor(private ngRegisterSectionsDatasource: IRegisterSectionsDatasource) {}
  $onChanges() {
    this.scheduledMultiSectionSessions = this.groupMultiSectionsByCourseId(this.scheduledMultiSections);
  }
  showCheckbox(sectionList: ISection[], sectionIndex: number): boolean {
    if (!sectionIndex) {
      return true;
    }
    if (sectionList[sectionIndex]._course.id === sectionList[sectionIndex - 1]._course.id) {
      return false;
    }
    return true;
  }
  groupMultiSectionsByCourseId(scheduledMultiSections: ISection[]): any {
    const restructuredData = scheduledMultiSections.reduce((multiSectionsHash, curr) => {
      const courseId = curr._course.id;

      multiSectionsHash[courseId] = multiSectionsHash[courseId] || [];
      multiSectionsHash[courseId].push(curr);

      return multiSectionsHash;
    }, {});
    return restructuredData;
  }
}

class PinScheduledSectionsComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      scheduledSections: '<',
      form: '@',
      scheduledMultiSections: '<'
    };
    this.controller = PinScheduledSections;
    this.templateUrl =
      'capability-ng-scheduler/src/views/registration/components/registration_pins/pins_scheduled_sections/pins_scheduled_sections.html';
  }
}
angular.module('capability-ng-scheduler').component('pinScheduledSections', new PinScheduledSectionsComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_pins/pins_scheduled_sections/pins_scheduled_sections.ts